import React, {useState, useEffect, useMemo} from "react";
import { TextField, Checkbox, FormControlLabel, FormHelperText, Grid, Typography, Box, Container, Button, FormLabel, RadioGroup, Radio, FormGroup, FormControl, Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import PdfModalViewer from "./PdfModalViewer.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedChangeWithError } from "./common/useValidatedChangeWithError.js";
import { intValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp8Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, conRepId, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);

  const [selectedPlans, setSelectedPlans] = useState([
  // 初期は空、選んだら { value, label, quantity } が入る
  ]);
  const [errors, setErrors] = useState({});

  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };


    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        corporate_type: conRepId,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      corporate_type: conRepId,
      role: "corporate"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const COLORS = ["レッド", "グリーン", "ブルー", "グレー"];
  const OUTLET_POSITIONS = ["A", "B", "C", "D"];
  const planOptions = [
    { label: "Aプラン（展示メイン・1ブースプラン）134,200円", value: "A" },
    { label: "Bプラン（商談メイン・1ブースプラン）135300円", value: "B" },
    { label: "Cプラン（展示メイン・2ブースプラン）178200円", value: "C" },
    { label: "Dプラン（商談メイン・2ブースプラン）181500円", value: "D" },
    { label: "Eプラン（商談メイン・島ブースプラン）357500円", value: "E" },
    { label: "Fプラン（展示メイン・島ブースプラン）484000円", value: "F" },
  ];
  const packagePrices = {
    "A": 134200,
    "B": 135300,
    "C": 178200,
    "D": 181500,
    "E": 357500,
    "F": 484000,
  };

  const addPlanPrices = {
    A: 15950,
    B: 15950,
    C: 6380,
    D: 36300,
  };

  const storagePrices = {
    normal: 64900,
    other: 72600,
  };
  const [checked, setChecked] = useState({
    pack: false,
    storage: false,
    iphone: false,
    add: false,
  });
  const [formData, setFormData] = useState({
    user_8_name: "",
    user_8_department: "",
    user_8_phone: "",
    user_8_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    plan: [],
    plate_select: false,
    plate_info: "",
    carpet_color: "",
    outlet: "",
    elec_select: false,
    elec_detail: 0,
    add_select: false,
    add_detail: "A:0,B:0,C:0,D:0",
    normal_box: 0,
    other_box: 0,
    smartphone: false,
    add_smartphone: 0,
    alfa_text: "",
    total: 0,
  });
  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");

  const handleValidatedChange = useValidatedChangeWithError(
    setFormData,
    setErrors
  );

  const totalPrice = useMemo(() => {
    return selectedPlans.reduce((sum, plan) => {
      const price = packagePrices[plan.value] || 0;
      return sum + price * plan.quantity;
    }, 0);
  }, [selectedPlans]);

  useEffect(() => {
    const planCost = packagePrices[formData.plan] || 0;

    // add_detail から A, B, C, D の値を抽出して計算
    const addValues = ["A", "B", "C", "D"].reduce((acc, key) => {
        const match = formData.add_detail?.match(new RegExp(`${key}:(\\d+)`));
        acc[key] = match ? Number(match[1]) : 0;
        return acc;
    }, {});

    const addCost =
        addValues["A"] * addPlanPrices.A +
        addValues["B"] * addPlanPrices.B +
        addValues["C"] * addPlanPrices.C +
        addValues["D"] * addPlanPrices.D;

    const storageCost =
        (formData.normal_box || 0) * storagePrices.normal +
        (formData.other_box || 0) * storagePrices.other;

    const smartphoneCost = formData.smartphone === null ? 0 : 64900;
    const addSmartphoneCost = (formData.add_smartphone || 0) * 19800;

    const total = planCost + addCost + storageCost + smartphoneCost + addSmartphoneCost;

    if (formData.total !== total) {  // ← ここで変化あるときだけ更新
        setFormData((prev) => ({
        ...prev,
        total,
        }));
    }
    }, [
        formData.plan,
        formData.add_detail,
        formData.normal_box,
        formData.other_box,
        formData.total,
        packagePrices,
        formData.smartphone,
        formData.add_smartphone,
        addPlanPrices.A,
        addPlanPrices.B,
        addPlanPrices.C,
        addPlanPrices.D,
        storagePrices.normal,
        storagePrices.other,
        ]
    );
  const handleCheckedChange = (e) => {
    const { name, checked: value } = e.target;

    setChecked((prev) => ({ ...prev, [name]: value }));

    if (!value) {
      setFormData((prev) => {
        let resetFields = {};

        if (name === "pack") {
          resetFields = {
            // プラン選択をリセット
            plate_select: false,
            plate_info: "",
            carpet_color: "",
            outlet: "",
            elec_select: false,
            elec_detail: "",
            add_select: false,
            add_detail: "A:0,B:0,C:0,D:0",
          };
          setSelectedPlans([]); // 選択プランもクリア
        }

        if (name === "storage") {
          resetFields = {
            normal_box: 0,
            other_box: 0,
          };
        }

        if (name === "iphone") {
          resetFields = {
            smartphone: null,
            add_smartphone: 0,
          };
          setChecked((prev) => ({ ...prev, add: null })); // ラジオもリセット
        }

        return { ...prev, ...resetFields };
      });
    } else if (name === "iphone") {
      // チェック入れたら初期化して「3台のみ」に
      setFormData((prev) => ({ ...prev, smartphone: false, add_smartphone: 0 }));
      setChecked((prev) => ({ ...prev, add: false }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked: isChecked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? isChecked : value,
    }));
  }

  const handleOutletClick = (pos) => {
    setFormData((prev) => ({ ...prev, outlet: pos }));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
        ...prev,
        [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_8_name: mypageData.user_name || "",
        user_8_department: mypageData.department || "",
        user_8_phone: mypageData.phone_number || "",
        user_8_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_8_name: "",
        user_8_department: "",
        user_8_phone: "",
        user_8_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false)
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  console.log(formData)

  useEffect(() => {
    const fetchO8InitialData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO8, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/o8submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o8Status = resStatus.data?.o8_status || "";
        const o8Data = resO8.data || {};
        const mypage = resMypage.data || {};

        if (o8Status === "申請しない") {
          setNotApply(true);
          setFormData({
            user_8_name: null,
            user_8_department: null,
            user_8_phone: null,
            user_8_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            plan: [],
            plate_select: null,
            plate_info: null,
            carpet_color: null,
            outlet: null,
            elec_select: null,
            elec_detail: null,
            add_select: null,
            add_detail: null,
            normal_box: null,
            other_box: null,
            smartphone: null,
            add_smartphone: null,
            alfa_text: null,
          });
          setSelectedPlans([]); // 申請しないなら selectedPlans も空に
        } else {
          if (
            Object.values(o8Data).some((v) => {
              if (Array.isArray(v)) return v.length > 0;
              return v !== "" && v !== null && v !== undefined;
            })
          ) {
            // formData に反映
            setFormData((prev) => ({
              ...prev,
              ...o8Data,
            }));

            if (
              o8Data.user_8_name === mypage.user_name &&
              o8Data.user_8_department === mypage.department &&
              o8Data.user_8_phone === mypage.phone_number &&
              o8Data.user_8_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }

            if (
              o8Data.invoice_company_name === mypage.company_name &&
              o8Data.invoice_user_name === mypage.user_name &&
              o8Data.invoice_email === mypage.email &&
              o8Data.invoice_address === mypage.address &&
              o8Data.invoice_tel === mypage.phone_number &&
              o8Data.invoice_zip === mypage.zip_code
            ) {
              setSameAsInvoice("same");
              setInvFieldsDisabled(true);
            } else {
              setInvFieldsDisabled(false);
            }

            // plan があれば selectedPlans にセット
            if (o8Data.plan && Array.isArray(o8Data.plan)) {
              setSelectedPlans(
                o8Data.plan.map((p) => ({
                  value: p.value,
                  label: p.label,
                  quantity: p.quantity || 1,
                }))
              );
            }

            // pack の条件
            const hasPack =
              o8Data.plan?.length > 0 ||
              o8Data.plate_select ||
              o8Data.plate_info ||
              o8Data.carpet_color ||
              o8Data.outlet ||
              o8Data.elec_select ||
              (o8Data.elec_detail && o8Data.elec_detail !== 0) ||
              o8Data.add_select ||
              (o8Data.add_detail && o8Data.add_detail !== "A:0,B:0,C:0,D:0");

            // storage の条件
            const hasStorage =
              (o8Data.normal_box && o8Data.normal_box !== 0) ||
              (o8Data.other_box && o8Data.other_box !== 0);

            // === iphone の条件（要求どおりに変更） ===
            // o8Data.smartphone が null または undefined のときだけ false。
            // それ以外（true/false/"true"/"false"/1/0 等）は true にする。
            // plus add_smartphone > 0 なら true（既存挙動）。
            const hasIphone = o8Data.smartphone !== null || (o8Data.add_smartphone && o8Data.add_smartphone > 0);

            const hasAdd =
              typeof o8Data.add_smartphone === "number" &&
              o8Data.add_smartphone > 0;

            setChecked({
              pack: !!hasPack,
              storage: !!hasStorage,
              iphone: !!hasIphone,
              add: !!hasAdd,
            });
          }

          setNotApply(false);
        }
      } catch (err) {
        console.error("O8初期データ取得エラー:", err);
      }
    };

    fetchO8InitialData();
  }, []);

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_8_name: "",
            user_8_department: "",
            user_8_phone: "",
            user_8_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            plan: [],
            plate_select: null,
            plate_info: null,
            carpet_color: null,
            outlet: null,
            elec_select: null,
            elec_detail: 0,
            add_select: null,
            add_detail: null,
            normal_box: null,
            other_box: null,
            smartphone: null,
            add_smartphone: null,
            alfa_text: null,
          });
          setSelectedPlans([]);
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        const errors = {};

        if (!notApply) {
          // 基本必須
          if (!formData.user_8_name) errors.user_8_name = "入力してください";
          if (!formData.user_8_phone) errors.user_8_phone = "入力してください";
          if (!formData.user_8_tel) errors.user_8_tel = "入力してください";
          if (!formData.invoice_company_name) errors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name) errors.invoice_user_name = "入力してください";
          if (!formData.invoice_email) errors.invoice_email = "入力してください";
          if (!formData.invoice_address) errors.invoice_address = "入力してください";
          if (!formData.invoice_zip) errors.invoice_zip = "入力してください";
          if (!formData.invoice_tel) errors.invoice_tel = "入力してください";

          // // チェックボックス系（pack / storage / iphone のどれか必須）
          // if (!checked.pack && !checked.storage && !checked.iphone) {
          //   errors.checked = "いずれか1つは必須選択です";
          // }

          // pack 選択時
        // if (checked.pack) {
        //     if (selectedPlans.length === 0) errors.plan = "選択してください";

        //     // 電気詳細
        //     if (formData.elec_select && (!formData.elec_detail || formData.elec_detail === 0)) {
        //       errors.elec_detail = "電気詳細は必須です";
        //     }

        //     // 追加詳細
        //     if (formData.add_select && (!formData.add_detail || formData.add_detail === "A:0,B:0,C:0,D:0")) {
        //       errors.add_detail = "追加プラン詳細を入力してください";
        //     }
        //   }

        //   // storage 選択時
        //   if (checked.storage) {
        //     if (
        //       (!formData.normal_box || formData.normal_box === 0) &&
        //       (!formData.other_box || formData.other_box === 0)
        //     ) {
        //       errors.storage = "倉庫のどちらかに入力をしてください";
        //     }
        //   }

        //   // iphone + add 選択時
        //   if (checked.iphone && checked.add) {
        //     if (!formData.add_smartphone || formData.add_smartphone === 0) {
        //       errors.add_smartphone = "スマホ追加数は必須です";
        //     }
        //   }
        }

        const fieldDisplayNames = {
          user_8_name: "担当者名",
          user_8_department: "担当部署",
          user_8_phone: "担当者携帯",
          user_8_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          checked: "希望プラン",
          plate_select: "社名板",
          carpet_color: "カーペットの色",
          outlet: "コンセント位置",
          elec_detail: "電気追加分",
          add_detail: "追加プラン詳細",
          add_smartphone: "スマホ追加台数",
          plan: "ベースプラン",
          storage: "出展者専用倉庫",
        };

        // エラーがあれば止める
        if (Object.keys(errors).length > 0) {
          setSubmitErrors(errors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(errors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        // =========================
        // サニタイズ処理
        // =========================
        const sanitizedFormData = { ...formData };

        // 数値フィールドを確実に数値にする
        ["normal_box", "other_box", "add_smartphone"].forEach((key) => {
          if (sanitizedFormData[key] === "" || sanitizedFormData[key] == null) {
            sanitizedFormData[key] = 0;
          } else {
            sanitizedFormData[key] = Number(sanitizedFormData[key]);
          }
        });

        // iphone の扱い
        if (!checked.iphone) {
          // ほんまに希望してへん（null or undefined）の場合だけリセット
          if (formData.smartphone === null || formData.smartphone === undefined) {
            sanitizedFormData.smartphone = null;
            sanitizedFormData.add_smartphone = 0;
          }
        } else {
          if (!checked.add) {
            sanitizedFormData.add_smartphone = 0;
          }
        }

        // pack 関連
        if (!checked.pack) {
          sanitizedFormData.plate_select = false;
          sanitizedFormData.plate_info = "";
          sanitizedFormData.carpet_color = "";
          sanitizedFormData.outlet = "";
          sanitizedFormData.elec_select = false;
          sanitizedFormData.elec_detail = 0;
          sanitizedFormData.add_select = false;
          sanitizedFormData.add_detail = "A:0,B:0,C:0,D:0";
        }

        // storage 関連
        if (!checked.storage) {
          sanitizedFormData.normal_box = 0;
          sanitizedFormData.other_box = 0;
        }

        // selectedPlansをformDataに反映
        sanitizedFormData.plan = selectedPlans;

        // 送信payload
        const payload = {
          exhibitor_id: exhibitorId,
          formData: sanitizedFormData,
          notApply: notApply,
        };

        const res = await api.post("/api/submit-o8", payload);

        if (res.status === 200) {
          if (!notApply) {
          setNoticeModalOpen(true);
          }
          alert("保存成功");
        } else {
          alert("保存失敗");
        }
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };
  const [open , setOpen] = useState(false);
  const [openColor , setOpenColor] = useState(false);

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 パッケージ申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .sm-w-100 {width: 100%;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0081BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0081bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed',width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">パッケージ装飾申込</Typography>
        <Container sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_8_name" value={formData.user_8_name} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_8_name} helperText={submitErrors.user_8_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_8_department" value={formData.user_8_department} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_8_department} helperText={submitErrors.user_8_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_8_phone" value={formData.user_8_phone} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_8_phone} helperText={submitErrors.user_8_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_8_tel" value={formData.user_8_tel} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_8_tel} helperText={submitErrors.user_8_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} error={!!submitErrors.invoice_company_name} helperText={submitErrors.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} error={!!submitErrors.invoice_user_name} helperText={submitErrors.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} error={!!submitErrors.invoice_email} helperText={submitErrors.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} error={!!submitErrors.invoice_zip} helperText={submitErrors.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} error={!!submitErrors.invoice_address} helperText={submitErrors.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} error={!!submitErrors.invoice_tel} helperText={submitErrors.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>
                <Box>
                    <Button variant="outlined" onClick={() => setOpen(true)}>出展の手引き該当ページを見る</Button>
                </Box>
                <PdfModalViewer
                    filePath="/しんきんビジネスフェア2026出展概要_0709.pdf"
                    isOpen={open}
                    onClose={() => setOpen(false)}
                    startPage={12}
                    endPage={17}
                />
                {/* <FormControl
                  required
                  error={!!submitErrors.water}   // エラー状態をここで反映
                  component="fieldset"
                  variant="standard"
                >
                <FormGroup row>
                    <FormControlLabel
                    control={<Checkbox name="pack" checked={checked.pack} onChange={handleCheckedChange} />}
                    label="パッケージ装飾を希望する"
                    />
                    <FormControlLabel
                    control={<Checkbox name="storage" checked={checked.storage} onChange={handleCheckedChange} />}
                    label="出展者専用倉庫を希望する"
                    />
                    <FormControlLabel
                    control={<Checkbox name="iphone" checked={checked.iphone} onChange={handleCheckedChange} />}
                    label="名刺交換用iPhoneを希望する"
                    />
                </FormGroup>
                <FormHelperText>
                  {submitErrors.pack || submitErrors.storage || submitErrors.iphone}
                </FormHelperText>
                </FormControl> */}

                {/* {checked.pack && (
                <> */}
                <Typography variant="h6" gutterBottom>
                  パッケージ装飾
                </Typography>
                <Box>
                  <FormGroup>
                    {planOptions.map((option) => {
                      const isSelected = selectedPlans.some(p => p.value === option.value);
                      return (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedPlans([...selectedPlans, { ...option, quantity: 1 }]);
                                } else {
                                  setSelectedPlans(selectedPlans.filter(p => p.value !== option.value));
                                }
                              }}
                            />
                          }
                          label={option.label}
                        />
                      );
                    })}
                  </FormGroup>

                  <Box>
                    {/* 選ばれたプランの数量入力欄 */}
                    {selectedPlans.map((plan, idx) => (
                      <TextField
                        key={plan.value}
                        type="number"
                        label={`${plan.label} の数量`}
                        value={plan.quantity}
                        onChange={(e) => {
                          const updated = [...selectedPlans];
                          updated[idx].quantity = Number(e.target.value);
                          setSelectedPlans(updated);
                        }}
                        sx={{ mt: 2 }}
                        error={!!submitErrors[`plan_${plan.value}`]}
                        helperText={submitErrors[`plan_${plan.value}`]}
                        slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                      />
                    ))}
                  </Box>

                  <Box mt={3}>
                    <Typography variant="h6">合計金額: {totalPrice?.toLocaleString()} 円</Typography>
                  </Box>

                  <FormControl fullWidth margin="normal" error={!!submitErrors.carpet_color}>
                    <FormLabel>カーペット色</FormLabel>
                    <Select
                      name="carpet_color"
                      value={formData.carpet_color}
                      onChange={handleChange}
                      sx={{mt:1}}
                    >
                      {COLORS.map((color) => (
                        <MenuItem key={color} value={color}>
                          {color}
                        </MenuItem>
                      ))}
                    </Select>
                    {!!submitErrors.carpet_color && (
                      <FormHelperText>{submitErrors.carpet_color}</FormHelperText>
                    )}
                  </FormControl>

                  {/* 社名板 */}
                  {/* <FormControl component="fieldset" margin="normal">
                    <FormLabel>社名板</FormLabel>
                    <RadioGroup
                      name="plate_select"
                      value={formData.plate_select ? "true" : "false"}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          plate_select: e.target.value === "true",
                        }))
                      }
                      row
                    >
                      <FormControlLabel value="true" control={<Radio />} label="希望する" />
                      <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                    </RadioGroup>
                  </FormControl>
                  {formData.plate_select && (
                    <>
                      <TextField
                        label="社名板へ記載する原稿"
                        name="plate_info"
                        value={formData.plate_info}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                      />
                      <Typography>
                        ロゴマーク、指定書台頭は別途費用が必要です。<br />
                        備考欄にて詳細をご入力ください。
                      </Typography>
                    </>
                  )}

                  
                  <FormControl fullWidth margin="normal" error={!!submitErrors.carpet_color}>
                    <FormLabel>カーペット色</FormLabel>
                    <Box>
                        <Button variant="outlined" onClick={() => setOpenColor(true)}>色見本を表示する</Button>
                    </Box>
                    <PdfModalViewer
                        filePath="/各種届出について.pdf"
                        isOpen={openColor}
                        onClose={() => setOpenColor(false)}
                        startPage={3}
                        endPage={3}
                    />
                    <Select
                      name="carpet_color"
                      value={formData.carpet_color}
                      onChange={handleChange}
                      sx={{mt:1}}
                    >
                      {COLORS.map((color) => (
                        <MenuItem key={color} value={color}>
                          {color}
                        </MenuItem>
                      ))}
                    </Select>
                    {!!submitErrors.carpet_color && (
                      <FormHelperText>{submitErrors.carpet_color}</FormHelperText>
                    )}
                  </FormControl>

                  <Typography sx={{ mt: 2 }} color="error">
                    ※複数プラン申請の場合は備考欄にて2つ目以降の希望をご入力ください。
                  </Typography> */}

                  {/* コンセント希望位置 */}
                  {/* <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    コンセント希望位置（クリックで選択）
                  </Typography>
                  <Box
                    sx={{
                      width: 150,
                      height: 150,
                      border: "2px solid #ccc",
                      position: "relative",
                      marginBottom: 1,
                    }}
                  >
                    {OUTLET_POSITIONS.map((pos, index) => {
                      const positionStyle = [
                        { top: 0, left: 0 },
                        { top: 0, right: 0 },
                        { bottom: 0, left: 0 },
                        { bottom: 0, right: 0 },
                      ][index];

                      return (
                        <Box
                          key={pos}
                          onClick={() => handleOutletClick(pos)}
                          sx={{
                            width: 70,
                            height: 70,
                            borderRadius: "50%",
                            backgroundColor:
                              formData.outlet === pos ? "#1976d2" : "#e0e0e0",
                            color: formData.outlet === pos ? "#fff" : "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "absolute",
                            cursor: "pointer",
                            ...positionStyle,
                          }}
                        >
                          {pos}
                        </Box>
                      );
                    })}
                    <Typography
                      variant="caption"
                      sx={{
                        position: "absolute",
                        bottom: -20,
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      正面
                    </Typography>
                  </Box>
                  <Typography sx={{ mt: 2 }} color="error">
                    ※複数プラン申請の場合は備考欄にて2つ目以降の希望をご入力ください。
                  </Typography>
                  {!!submitErrors.outlet && (
                    <FormHelperText error>{submitErrors.outlet}</FormHelperText>
                  )} */}

                  {/* 追加電気工事
                  <FormControl component="fieldset" margin="normal">
                    <FormLabel>追加電気工事</FormLabel>
                    <RadioGroup
                      name="elec_select"
                      value={formData.elec_select ? "true" : "false"}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          elec_select: e.target.value === "true",
                        }))
                      }
                      row
                    >
                      <FormControlLabel value="true" control={<Radio />} label="希望する" />
                      <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                    </RadioGroup>
                    {formData.elec_select && (
                      <TextField
                        label="追加分（kW）"
                        name="elec_detail"
                        type="number"
                        value={formData.elec_detail}
                        onChange={handleChange}
                        margin="dense"
                        fullWidth
                        inputProps={{ min: 0 }}
                        error={!!submitErrors.elec_detail}
                        helperText={submitErrors.elec_detail}
                        slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                      />
                    )}
                    {formData.elec_select && (
                      <Typography variant="caption" color="text.secondary">
                        ※1kWを超える場合、追加分をご記入ください。
                      </Typography>
                    )}
                  </FormControl> */}

                  {/* 追加プラン */}
                  {/* <Box>
                    <FormControl component="fieldset" margin="normal">
                      <FormLabel>追加プラン</FormLabel>
                      <RadioGroup
                        name="add_select"
                        value={formData.add_select ? "true" : "false"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            add_select: e.target.value === "true",
                          }))
                        }
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="希望する" />
                        <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                      </RadioGroup>

                      {formData.add_select && (
                        <>
                          <Box display="flex" gap={2} flexWrap="wrap">
                            {["A", "B", "C", "D"].map((key) => {
                              const detail = formData.add_detail ?? "A:0,B:0,C:0,D:0";
                              const regex = new RegExp(`${key}:(\\d+)`);
                              const match = detail.match(regex);
                              const value = match ? Number(match[1]) : 0;

                              return (
                                <TextField
                                  key={key}
                                  label={`追加プラン ${key}`}
                                  name={`add_${key}`}
                                  type="number"
                                  value={value}
                                  onChange={(e) => {
                                    const newVal = e.target.value;
                                    setFormData((prev) => {
                                      let detail = prev.add_detail ?? "A:0,B:0,C:0,D:0";
                                      const regex = new RegExp(`${key}:(\\d+)`);
                                      if (regex.test(detail)) {
                                        detail = detail.replace(regex, `${key}:${newVal}`);
                                      } else {
                                        detail += `,${key}:${newVal}`;
                                      }
                                      return { ...prev, add_detail: detail };
                                    });
                                  }}
                                  margin="dense"
                                  sx={{ width: "100px" }}
                                  inputProps={{ min: 0 }}
                                  error={!!submitErrors.add_detail}
                                  helperText={submitErrors.add_detail}
                                  slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                              );
                            })}
                          </Box>
                          <Box>
                            <Typography>
                              【追加プラン金額一覧】<br />
                              〇追加プランA 15,950円（税込）<br />
                              〇追加プランB 15,950円（税込）<br />
                              〇追加プランC 6,380円（税込）<br />
                              〇追加プランD 36,300円（税込）
                            </Typography>
                          </Box>
                        </>
                      )}
                    </FormControl>
                  </Box> */}
                </Box>
                {/* </>
                )} */}

                {/* {checked.storage && (
                    <Box>
                    <Typography variant="h6" gutterBottom>
                      出展者専用倉庫
                    </Typography>
                    <Typography>
                      必要数を入力してください。
                    </Typography>
                    <TextField
                      label="出展者専用倉庫(通常タイプ)"
                      value={formData.normal_box}
                      onChange={handleValidatedChange(
                        "normal_box",
                        intValidator({ label: "通常タイプ" })
                      )}
                      type="number"
                      fullWidth
                      margin="normal"
                      error={!!errors.normal_box}
                      helperText={errors.normal_box}
                      onWheel={(e) => e.target.blur()}
                      inputProps={{ min: 0 }}
                    />

                    <TextField
                      label="出展者専用倉庫(着ぐるみ対応タイプ)"
                      value={formData.other_box}
                      onChange={handleValidatedChange(
                        "other_box",
                        intValidator({ label: "着ぐるみ対応タイプ" })
                      )}
                      type="number"
                      fullWidth
                      margin="normal"
                      error={!!errors.other_box}
                      helperText={errors.other_box}
                      onWheel={(e) => e.target.blur()}
                      inputProps={{ min: 0 }}
                    />
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                      <img src="/storage.png" alt="出展者専用倉庫説明図" className="sm-w-100" />
                    </Box>
                    </Box>
                )}

                {checked.iphone && (
                  <Box>
                    <FormControl
                      component="fieldset"
                      margin="normal"
                      error={!!submitErrors.add_smartphone} // ← ここ追加
                    >
                      <FormLabel>名刺交換用iPhoneパッケージプラン</FormLabel>
                      <RadioGroup
                        row
                        value={checked.add ? "add" : "default"}
                        onChange={(e) => {
                          const isAdd = e.target.value === "add";
                          setChecked((prev) => ({ ...prev, add: isAdd }));

                          if (!isAdd) {
                            setFormData((prev) => ({ ...prev, add_smartphone: 0 }));
                          }
                        }}
                      >
                        <FormControlLabel
                          value="default"
                          control={<Radio />}
                          label="名刺読み取り用端末（iPhone）3台のみ"
                        />
                        <FormControlLabel
                          value="add"
                          control={<Radio />}
                          label="台数を追加する"
                        />
                      </RadioGroup>
                      {submitErrors.add_smartphone && (
                        <FormHelperText>{submitErrors.add_smartphone}</FormHelperText>
                      )}
                    </FormControl>

                    {checked.add && (
                      <TextField
                        label="追加iPhone台数"
                        value={formData.add_smartphone}
                        onChange={handleValidatedChange(
                          "add_smartphone",
                          intValidator({ label: "追加iPhone台数" })
                        )}
                        type="number"
                        fullWidth
                        margin="normal"
                        error={!!errors.add_smartphone}
                        helperText={errors.add_smartphone}
                        onWheel={(e) => e.target.blur()}
                        inputProps={{ min: 0 }}
                      />
                    )}
                    
                    <Typography>名刺読み取り用iPhone(3台のみ) ： 64900円（税込）</Typography>
                    <Typography>追加iPhone(1台につき) ： 19800円（税込）</Typography>
                  </Box>
                )} */}

                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※パッケージ装飾申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            )}
        </Container>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            ビジネスフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
        <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
          <DialogTitle>注意事項</DialogTitle>
          <DialogContent>
            <p>
              追加プランA～Dをご注文された場合は、設置位置を「ブース平面図」よりご提出ください。
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotice} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
        <Box display="flex" justifyContent="center" gap={2} mt={2}>
          <Button
            variant="contained"
            onClick={handleCorrection}
            sx={{
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
            }}
          >
            再提出
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleConfirm}
          >
            完了
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => setFormModalOpen(false)}
          >
            中断
          </Button>
        </Box>
        )}
    </div>
  );
};

export default Comp8Sub;
